import { EnterpriseStatus } from '../enums/enterprise-status.enum';
import { Serializable, Serialized, SerializeUtil } from '../utils/serialize';

export class Enterprise implements Serializable {
  @Serialized() public name: string;
  @Serialized() public status: EnterpriseStatus;
  @Serialized() public privacyPolicyUrl: string;
  @Serialized() protected _id: string;

  public get id(): string {
    return this._id;
  }

  public set id(id: string) {
    this._id = id;
  }

  constructor(backEndEnterprise?: BackEndEnterprise) {
    if (backEndEnterprise) {
      this.id = backEndEnterprise.id;
      this.name = backEndEnterprise.name;
      this.status = backEndEnterprise.status;
      this.privacyPolicyUrl = backEndEnterprise.privacy_policy_url;
    }
  }

  public toBackEnd(): BackEndEnterprise {
    return {
      id: this.id,
      name: this.name,
      status: this.status,
      privacy_policy_url: this.privacyPolicyUrl,
    } as BackEndEnterprise;
  }

  public toBackEndPatch(): BackEndEnterprisePatch {
    return {
      name: this.name,
      status: this.status,
      privacy_policy_url: this.privacyPolicyUrl,
    };
  }

  public clone(): Enterprise {
    const serialized = this.serialize();
    return Enterprise.deserialize(serialized);
  }

  public serialize(): string {
    return SerializeUtil.deepSerialize(this);
  }

  public static deserialize(serialized: string | object): Enterprise {
    return SerializeUtil.deepDeserialize(new Enterprise(), serialized);
  }
}

export interface BackEndEnterprise {
  id: string;
  name: string;
  status: EnterpriseStatus;
  privacy_policy_url?: string;
}

export interface BackEndEnterprisePatch {
  name?: string;
  status?: EnterpriseStatus;
  privacy_policy_url?: string;
}
